import React, { PureComponent } from 'react'

import Layout from '../../components/Layout/Layout'

import Shell from '../Shell/GuidePageShellContainer'
import * as seoUtils from '../../utils/seoUtils'
import { makeSearch } from '../../utils/breadcrumbUtils'
import { TRACK_CHANNEL, getProductDetailTrackChannel } from '../../utils/Store/productUtils'

import SalesEventsService from '../../services/SalesEventsService'
import ProductService from '../../services/ProductService'

const fetchPageData = ({ $http, $router, $detector }) => {
  const service = new SalesEventsService($http)
  const handle = $router.match.params.handle

  return service.fetchPageData(
    SalesEventsService.makePageDataArgs({ $router, handle, $detector })
  )
}

const fetchOpenGraphInfo = ({ data }, { $router, $site }) => {
  const { title = '', description } = data || {}

  const jsonLD = [
    seoUtils.forBreadcrumb()
  ]

  let image = seoUtils.extractBannerFromDSL(data)
  const products = seoUtils.extractMainProductsFromDsl(data)
  const subLinks = seoUtils.extractGridLinksFromDSL(data)

  const productLinks = (products || []).map(productQueueItem => {
    const link = {
      name: 'Product',
      params: {
        handle: productQueueItem.product.handle
      }
    }
    return $router.getFinalPath(link)
  })

  subLinks.push(...productLinks)

  if (subLinks) {
    jsonLD.push(
      seoUtils.forItemListSummary(subLinks)
    )
  }

  if (!image) {
    const firstProduct = products[0]
    image = firstProduct && firstProduct.product ? firstProduct.product.mainImage : undefined
  }

  const site = $site.getSiteInfo()

  return {
    title: title ? `${title} - ${site.fullSiteName}` : undefined,
    description: description,
    image,
    jsonLD: jsonLD
  }
}

class PlainSalesEventContainer extends PureComponent {
  productService = new ProductService(this.props.$http)

  componentDidMount() {
    // don't take coupon in app
    const { promotions } = this.props.data

    // take coupon automatically
    const selectedPromotions = promotions.filter(promotionId => promotionId).map(id => ({ id }))

    if (selectedPromotions.length > 0) {
      this.props.$store.couponHub.highlight(selectedPromotions)
    }
  }

  render() {
    const layoutProps = this.props.data
    const trackChannel = getProductDetailTrackChannel(this.props.location)

    return (
      <Layout
        {...layoutProps}
        productService={this.productService}
        productListToExtraInfo={{
          search: {
            ...makeSearch({
              title: layoutProps.title,
              routeName: 'SalesEvents',
              routeHandle: layoutProps.handle
            }),
            [TRACK_CHANNEL]: trackChannel
          }
        }}
      ></Layout>
    )
  }
}

class SalesEventsContainer extends PureComponent {
  static Shell = Shell
  static shellProps = () => {
    return {
      promotion: true,
      supportDesktop: true,
      showShippingBar: true,
      footHintHeight: 0
    }
  }

  static fetchOpenGraphInfo = fetchOpenGraphInfo
  static fetchPageData = fetchPageData

  render() {
    return (
      <PlainSalesEventContainer {...this.props}></PlainSalesEventContainer>
    )
  }
}

export {
  fetchOpenGraphInfo,
  fetchPageData,
  PlainSalesEventContainer
}

export default SalesEventsContainer
